import {
  EnrollType,
  EnrollmentConfigState,
  EnrollmentObjectType,
  EnrollmentTriggerPayload,
  ExpirationKind,
  ExpirationType,
} from "../types";

export interface OptionItem<T extends string> {
  value: T;
  labelKey: string;
}

export const ENROLL_TYPE_OPTIONS: OptionItem<EnrollType>[] = [
  { value: "TOP", labelKey: "config.enroll-type.options.top" },
  {
    value: "TOP_MANDATORY",
    labelKey: "config.enroll-type.options.top-mandatory",
  },
  { value: "AUTO", labelKey: "config.enroll-type.options.auto" },
  { value: "BOTTOM", labelKey: "config.enroll-type.options.bottom" },
  { value: "PRE_AUTO", labelKey: "config.enroll-type.options.pre-auto" },
  { value: "PRE_BOTTOM", labelKey: "config.enroll-type.options.pre-bottom" },
];

export const EXPIRATION_KIND_OPTIONS: OptionItem<ExpirationKind>[] = [
  {
    value: "fixed-date",
    labelKey: "config.expiration-kind.options.fixed-date",
  },
  {
    value: "completion-days",
    labelKey: "config.expiration-kind.options.completion-days",
  },
];

export const EXPIRATION_TYPE_OPTIONS: OptionItem<ExpirationType>[] = [
  { value: "hard", labelKey: "config.expiration-type.options.hard" },
  { value: "soft", labelKey: "config.expiration-type.options.soft" },
];

const BASE_DISABLED_BY_OBJECT_TYPE: Record<EnrollmentObjectType, EnrollType[]> =
  {
    activity: ["AUTO", "BOTTOM"],
    course: ["AUTO", "BOTTOM"],
    path: ["AUTO", "BOTTOM"],
  };

export const getDisabledEnrollTypes = (
  trigger: EnrollmentTriggerPayload | null,
): EnrollType[] => {
  if (!trigger) return [];
  if (trigger.objectType === "course" && trigger.isEcm) {
    return ["AUTO", "BOTTOM", "PRE_AUTO", "PRE_BOTTOM"];
  }
  return BASE_DISABLED_BY_OBJECT_TYPE[trigger.objectType] ?? [];
};

export const isTopEnrollType = (et?: EnrollType): boolean =>
  et === "TOP" || et === "TOP_MANDATORY";

export const buildInitialConfig = (): EnrollmentConfigState => ({
  enableExpiration: false,
  attributesIds: [],
});

export interface ConfigValidationResult {
  valid: boolean;
  errors: Partial<Record<keyof EnrollmentConfigState, string>>;
}

export const validateConfig = (
  config: EnrollmentConfigState,
): ConfigValidationResult => {
  const errors: ConfigValidationResult["errors"] = {};
  if (!config.enrollType) errors.enrollType = "required";
  if (config.enableExpiration) {
    if (!config.expirationType) errors.expirationType = "required";
    if (config.expirationKind === "fixed-date" && !config.expirationDate) {
      errors.expirationDate = "required";
    }
    if (
      config.expirationKind === "completion-days" &&
      (config.daysToComplete === undefined || config.daysToComplete <= 0)
    ) {
      errors.daysToComplete = "required";
    }
  }
  return { valid: Object.keys(errors).length === 0, errors };
};
